import React from "react";

const CaseDetails = ({ caseDetails }) => (
  <div>
    <h4 className="bold">
      Transaction Reference: {caseDetails.transactionReference}
    </h4>
    <p className="text-info">
      Created by {caseDetails.createdBy} on {caseDetails.createdOn}
    </p>
    <hr />
    <div className="row dnds-trans-details">
      {caseDetails.caseStatusDescription && (
        <div className="col-sm-4 dnds-detail">
          <div>
            <strong>Case Status: </strong>{" "}
            <span>{caseDetails.caseStatusDescription}</span>
          </div>
        </div>
      )}
      {caseDetails.subStatusCodeDescription && (
        <div className="col-sm-6 dnds-detail">
          <div>
            <strong>Case Sub Status: </strong>{" "}
            <span>{caseDetails.subStatusCodeDescription}</span>
          </div>
        </div>
      )}
      {caseDetails.reason && (
        <div className="col-sm-4 dnds-detail">
          <div>
            <strong>Reason: </strong> <span>{caseDetails.reason}</span>
          </div>
        </div>
      )}
      {caseDetails.motive && (
        <div className="col-sm-6 dnds-detail">
          <div>
            <strong>Motive: </strong> <span>{caseDetails.motive}</span>
          </div>
        </div>
      )}
    </div>
    <hr />
    <div className="row dnds-trans-details">
      {caseDetails.caseNumber && (
        <div className="col-sm-4 dnds-detail">
          <div>
            <strong>Case Number: </strong>{" "}
            <span>{caseDetails.caseNumber} </span>
          </div>
        </div>
      )}
      {caseDetails.dnCaseNumber && (
        <div className="col-sm-4 dnds-detail">
          <div>
            <strong>DN Case Number: </strong>{" "}
            <span>{caseDetails.dnCaseNumber}</span>
          </div>
        </div>
      )}
      {caseDetails.issuer && (
        <div className="col-sm-4 dnds-detail">
          <div>
            <strong>Issuer: </strong> <span>{caseDetails.issuer}</span>
          </div>
        </div>
      )}
      {caseDetails.merchant && (
        <div className="col-sm-4 dnds-detail">
          <div>
            <strong>Merchant: </strong> <span>{caseDetails.merchant}</span>
          </div>
        </div>
      )}
      {caseDetails.cycleCreationDate && (
        <div className="col-sm-4 dnds-detail">
          <div>
            <strong>Cycle Creation Date: </strong>{" "}
            <span>{caseDetails.cycleCreationDate}</span>
          </div>
        </div>
      )}
      {caseDetails.cycleCloseDate && (
        <div className="col-sm-4 dnds-detail">
          <div>
            <strong>Expiry Date: </strong>{" "}
            <span>{caseDetails.cycleCloseDate}</span>
          </div>
        </div>
      )}
      {caseDetails.acquirerCode && (
        <div className="col-sm-4 dnds-detail">
          <div>
            <strong>Acquirer Code: </strong>{" "}
            <span>{caseDetails.acquirerCode}</span>
          </div>
        </div>
      )}
      {caseDetails.caseAmount && (
        <div className="col-sm-4 dnds-detail">
          <div>
            <strong>Case Amount: </strong> <span>{caseDetails.caseAmount}</span>
          </div>
        </div>
      )}
      {caseDetails.transactionAmount && (
        <div className="col-sm-4 dnds-detail">
          <div>
            <strong>Transaction Amount: </strong>{" "}
            <span>{caseDetails.transactionAmount}</span>
          </div>
        </div>
      )}
      {caseDetails.noticeType && (
        <div className="col-sm-4 dnds-detail">
          <div>
            <strong>Notice Type: </strong> <span>{caseDetails.noticeType}</span>
          </div>
        </div>
      )}
      {caseDetails.caseInFavorOf && (
        <div className="col-sm-4 dnds-detail">
          <div>
            <strong>Case In Favor Of: </strong>{" "}
            <span>{caseDetails.caseInFavorOf}</span>
          </div>
        </div>
      )}
      {caseDetails.daysInDispute.toString() && (
        <div className="col-sm-4 dnds-detail">
          <div>
            <strong>Days In Dispute: </strong>{" "}
            <span>{caseDetails.daysInDispute} Days</span>
          </div>
        </div>
      )}
    </div>
  </div>
);

export default CaseDetails;



// WEBPACK FOOTER //
// ./src/components/discover/cases/caseDetail/CaseDetails.js